import Typography from "@components/Typography";

import styles from "./FilterCountIndicator.module.css";

type FilterCountIndicatorProps = {
  count: number;
};

const FilterCountIndicator: React.FunctionComponent<
  FilterCountIndicatorProps
> = ({ count }) => {
  return count > 0 ? (
    <Typography variant="caption" className={styles.root} align="center">
      {count}
    </Typography>
  ) : null;
};

export default FilterCountIndicator;
